import { useQuery } from '@tanstack/react-query';
import config from 'config';
import { useAuthContext } from 'modules/auth/context';
import { FEATURES } from 'modules/entitlements/constants';
import { GetEntitlements } from 'modules/entitlements/api';
import { IS_IO } from 'lib/site';

/** Live org opt-in for the Access page; the backend still checks every publishing write. */
export function useMarketplacePublishing(organizationId?: string) {
  const { state } = useAuthContext();
  const activeOrgId = () => localStorage.getItem(config.api.active_org_key) || state.organization?.id;
  const matchesActiveOrg = Boolean(organizationId && organizationId === activeOrgId());
  const query = useQuery({
    queryKey: ['marketplace-publishing', state.user?.id, organizationId],
    // examing.io has no marketplace (the API refuses it too), so the option never appears there.
    enabled: Boolean(state.user?.id) && matchesActiveOrg && !IS_IO,
    queryFn: async ({ signal }) => {
      if (organizationId !== activeOrgId()) throw new Error('Active organization changed');
      const { data } = await GetEntitlements(signal);
      if (organizationId !== activeOrgId()) throw new Error('Active organization changed');
      return data;
    },
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    refetchInterval: 60_000,
    retry: false,
  });
  return {
    canPublish: !IS_IO && matchesActiveOrg && query.isFetchedAfterMount && !query.isError &&
      query.data?.features[FEATURES.MARKETPLACE_PUBLISH]?.enabled === true,
    refetch: query.refetch,
  };
}
